<template>
    <div class="container mt-3">
        <b-card class="text-center">
            <b-row class="treasury-logo p-1" align-v="end">
                <b-col cols="2">
                    <img class="p-1" src="~@/assets/images/grb.svg">
                </b-col>
                <b-col>
                    <div class="p-2">
                        <label>РЕПУБЛИКА СРБИЈА</label>
                        <label>МИНИСТАРСТВО ФИНАНСИЈА</label>
                        <label style="font-weight: 800">УПРАВА ЗА ТРЕЗОР</label>
                    </div>
                </b-col>
            </b-row>
            <b-row style="height: 35px;">                
            </b-row>
            
             <b-card bg-variant="danger"
                text-variant="white"
                class="text-center">
                <p class="card-text">{{$t('notFound')}}</p>
            </b-card>
            

            <b-row style="height: 50px;">                
            </b-row>
             <b-row align-h="center" class="mt-3">
                <a :href="changelogPath">
                    <span>{{$t('general.changelog')}}</span>
                </a>
            </b-row>
            <b-row align-h="center" class="mt-5">
                <a :href="supportPath">
                    <span>{{$t('general.technicalSupport')}}</span>
                </a>
            </b-row>
        </b-card>
    </div>
</template>

<script>
  import Vue from 'vue'

  export default {
    name: 'notfound-page',
    created () {
      this.changelogPath = (Vue.$config.help_root + '/changelog/').replace(/([^:]\/)\/+/g, '$1')
      this.supportPath = (Vue.$config.help_root + '/support/').replace(/([^:]\/)\/+/g, '$1')
    }
  }

</script>

<style lang="scss" type="text/scss">
    @import '~@/assets/scss/variables.scss';

    .treasury-logo {
        height: 75px;
        width: 260px;
        margin: 0 auto;
        img {
            width: 55px;
            height: 75px;
        }
        label {
            display: block;
            font-size: 8pt;
            font-weight: 600;
            margin: 0px;
        }
    }

    .danger-notification-icon {
      width: 28px;
      height: 28px;
      line-height: 32px;
      margin: 0px;
      margin-right: 15px;
    }

    .not-found-label {
        color: $primary-color;
        font-weight: 600;
        font-size: 13pt;
    }

</style>



// WEBPACK FOOTER //
// NotFoundPage.vue?0f941565